import { useUnsavedPageWarning } from "../contexts/UnsavedPageWarningContext";

/**
 * Hook to check if form save buttons should be disabled due to active dictation.
 * 
 * When dictation is active, the transcript is only displayed in the UI but not yet
 * committed to the form state. Saving the form during active dictation would lose
 * the in-progress transcript.
 * 
 * Usage:
 * ```tsx
 * const { isDictationActive } = useDictationCheck();
 * 
 * <Button
 *   disabled={isFormInvalid || loading || isDictationActive}
 *   onClick={handleSave}
 * >
 *   Save
 * </Button>
 * ```
 */
export const useDictationCheck = () => {
  const { isDictationActive } = useUnsavedPageWarning();
  
  return {
    isDictationActive,
  };
};
